module.exports = __webpack_public_path__ + "static/media/card_suits_diamond.6db02be0.png";